import React from "react";
import { colors } from "../../constants/colors";
import contactUsImage from "../../images/contactUsImage.png";
export const ContactUsBanner = () => {
  return (
    <section
      className="contact-us-banner"
      id="contact-us-banner"
      // data-aos="fade-right"
      // data-aos-anchor-placement="top-center"
      style={{ backgroundColor: colors.gencLightBlue }}
    >
      <div className="row no-gutters">
        <div className="contact-us-banner-details d-flex justify-content-center align-items-center col-xs-12 text-center col-sm-12 col-md-5 text-md-left">
          <div className="p-5" data-aos="fade-left" data-aos-delay="250">
            <h1 style={{ color: colors.gencBlue }}>GenC Support</h1>
            <p style={{ color: colors.gencBlack }}>
            For GenC Health-box and Family Circles app support please send an email to supportATgenclabsDOTcom.
            </p>
          </div>
        </div>
        <div
          className="col-xs-12 col-sm-12 col-md-7"
          data-aos="fade-right"
          data-aos-delay="250"
        >
          <img src={contactUsImage} alt="Team Hands" />
        </div>
      </div>
    </section>
  );
};
